// CoverActionButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './CoverActionButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * CoverActionButton
 *
 * Compact overlay control for cover photo actions (edit, zoom, remove).
 *
 * @param {string} iconKey - Icon key to render.
 * @param {string} [title] - Tooltip / accessible label.
 * @param {Function} onClick - Click handler.
 *
 * @returns {ReactNode} CoverActionButton.
 */
const CoverActionButton = React.memo(({ iconKey, title, onClick }) => {

  // ----- CONTEXT ----- //

  // Theme Context

  const { theme } = useTheme();

  // ----- STATE ----- //

  // Hover highlight for the compact overlay control.
  const [hovered, setHovered] = useState(false);

  // ----- RENDER ----- //

  return (
    <div
      className="cover-action-button-container"
      style={{
        backgroundColor: hovered ? theme.buttonHoverBackgroundColor : theme.backgroundMuted,
        boxShadow: hovered ? `0 0 8px ${theme.background}` : 'none',
        transform: hovered ? 'scale(1.03)' : 'scale(1)',
      }}
      role="button"
      title={title}
      onClick={onClick}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Icon
        iconKey={iconKey}
        color={hovered ? theme.buttonHoverLabelColor : theme.foreground}
        width={20}
        height={20}
      />
    </div>
  );
});

// Dev Tools
CoverActionButton.displayName = 'CoverActionButton';

export default CoverActionButton;
